module.exports = __webpack_public_path__ + "static/media/firefox.288f218d.svg";